module.exports = __webpack_public_path__ + "img/nach-img.de26f277.png";